import React from 'react';
import { PageTitle } from '@cordata/buffet';

import Form from '~/components/PasswordPolicy/Form';

const PasswordPolicy = () => (
  <React.Fragment>
    <PageTitle>Password Policy</PageTitle>

    <Form />
  </React.Fragment>
);

export default PasswordPolicy;
